import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-basic-modal',
  templateUrl: './basic-modal.component.html',
  styleUrls: ['./basic-modal.component.scss'],
})
export class BasicModalComponent implements OnInit {
  @Input() title: string = '';
  @Input() content: string = '';

  @Input() buttonText?: string;
  @Input() showCloseCTA?: boolean = true;

  @Output() handleOnClickBtn = new EventEmitter<any>();

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    console.log('[ModalBodyComponent] Modal OnInit');
  }

  async onClickBtn() {
    this.handleOnClickBtn.emit();
    this.activeModal.dismiss('Back click');
  }
}
